export const title = 'Average ticket (Chart)';

Trend of average sales ticket over time.
